import { render } from "./doctor-select.vue?vue&type=template&id=fe75d462&scoped=true"
import script from "./doctor-select.vue?vue&type=script&lang=js"
export * from "./doctor-select.vue?vue&type=script&lang=js"

import "./doctor-select.vue?vue&type=style&index=0&id=fe75d462&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe75d462"]])

export default __exports__